// src/pages/Store.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Store() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#9BE7FF] via-[#FDF7FF] to-[#FFE8C7]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        {/* Header */}
        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="text-xl sm:text-2xl font-extrabold text-[#1D4ED8] hover:opacity-90"
          >
            Treble Town
          </button>

          <button
            type="button"
            onClick={() => navigate(-1)}
            className="px-4 py-2 rounded-full border border-slate-200 bg-white/90 text-slate-700 font-semibold hover:bg-white"
          >
            ← Back
          </button>
        </div>

        {/* Card */}
        <div className="mt-8 bg-white/85 border border-white/80 shadow-2xl rounded-[28px] overflow-hidden">
          <div className="p-6 sm:p-10">
            <div className="flex flex-col items-center text-center">
              <div className="relative">
                <div className="absolute inset-0 blur-2xl bg-gradient-to-tr from-[#7BD5FF] via-[#A78BFA] to-[#FFCF71] opacity-60 rounded-full" />
                <div className="relative z-[1] w-20 h-20 sm:w-24 sm:h-24 rounded-3xl bg-white flex items-center justify-center shadow-xl border border-slate-100">
                  <span className="text-4xl sm:text-5xl">🛍️</span>
                </div>
              </div>

              <h1 className="mt-5 text-2xl sm:text-4xl font-black text-slate-900">
                Store Coming Soon!
              </h1>

              <p className="mt-3 text-sm sm:text-base text-slate-600 max-w-xl">
                We’re cooking up some magical goodies for your Star Quest —
                printable worksheets, rewards, collectibles, and more.
              </p>

              <div className="mt-6 w-full max-w-xl">
                <div className="h-3 rounded-full bg-slate-200 overflow-hidden border border-slate-100">
                  <div
                    className="h-full rounded-full animate-pulse"
                    style={{ width: "62%" }}
                  />
                </div>
                <div className="mt-2 text-[11px] sm:text-xs text-slate-500">
                  Building the Treble Town Store… ✨
                </div>
              </div>

              <div className="mt-8 flex flex-wrap gap-3 justify-center">
                <button
                  type="button"
                  onClick={() => navigate("/pricing")}
                  className="px-6 py-3 rounded-full bg-[#FFC94E] border-[3px] border-[#456EFF] shadow-[0_10px_0_#E0862B] text-slate-900 font-extrabold uppercase text-sm active:translate-y-[2px] active:shadow-[0_8px_0_#E0862B] transition-transform"
                >
                  View Pricing
                </button>

                <button
                  type="button"
                  onClick={() => navigate("/parents")}
                  className="px-6 py-3 rounded-full bg-white border-2 border-slate-200 shadow-sm text-slate-800 font-extrabold uppercase text-sm hover:bg-slate-50 active:translate-y-[1px] transition"
                >
                  Parents Corner
                </button>

                <button
                  type="button"
                  onClick={() => navigate("/about")}
                  className="px-6 py-3 rounded-full bg-white border-2 border-slate-200 shadow-sm text-slate-800 font-extrabold uppercase text-sm hover:bg-slate-50 active:translate-y-[1px] transition"
                >
                  About Us
                </button>
              </div>

              <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3 w-full max-w-4xl">
                <div className="rounded-2xl bg-white border border-slate-100 p-4 shadow-sm">
                  <div className="text-lg">🎁</div>
                  <div className="mt-1 font-extrabold text-slate-900 text-sm">
                    Rewards & Gifts
                  </div>
                  <div className="text-xs text-slate-600 mt-1">
                    Fun prizes for completing levels.
                  </div>
                </div>

                <div className="rounded-2xl bg-white border border-slate-100 p-4 shadow-sm">
                  <div className="text-lg">📘</div>
                  <div className="mt-1 font-extrabold text-slate-900 text-sm">
                    Learning Packs
                  </div>
                  <div className="text-xs text-slate-600 mt-1">
                    Worksheets, games, and practice sheets.
                  </div>
                </div>

                <div className="rounded-2xl bg-white border border-slate-100 p-4 shadow-sm">
                  <div className="text-lg">⭐</div>
                  <div className="mt-1 font-extrabold text-slate-900 text-sm">
                    Star Quest Items
                  </div>
                  <div className="text-xs text-slate-600 mt-1">
                    Collectibles made just for kids.
                  </div>
                </div>
              </div>

              <div className="mt-8 text-[11px] sm:text-xs text-slate-500">
                Want something in the Store first? Tell us and we’ll prioritize it.
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center text-[11px] sm:text-xs text-slate-500">
          © {new Date().getFullYear()} Treble Town • Store opens soon ✨
        </div>
      </div>
    </div>
  );
}